import {Grid, Typography, TextField, DialogActions, Button} from '@mui/material';
import {useState} from 'react';
import {useAddLatestUpdate} from '../../../../api/latestupdate';
import {generateId} from '../../../../common/utils';

export const AddNewTextUpdateComponent = ({
    refetch,
    throwSnackbarMessage,
}: {
    throwSnackbarMessage: (message: string) => void;
    refetch: VoidFunction;
}) => {
    const [text, setText] = useState<string | undefined>();
    const {addTextLatestUpdate} = useAddLatestUpdate();

    const addingNewTextInput = () => {
        if (text) {
            addTextLatestUpdate({
                data: {
                    updateType: 'Text',
                    text: text,
                    cb: refetch,
                },
                throwSnackbarMessage: throwSnackbarMessage,
            });
        } else {
            throwSnackbarMessage('No file is selected');
        }
    };

    return (
        <Grid container>
            <Grid item md={12} xs={12} sm={12}>
                <Typography
                    sx={{
                        marginTop: 1,
                        fontWeight: 700,
                        color: 'black',
                        fontFamily: 'Poppins',
                    }}
                    variant='body1'>
                    Add new text update
                </Typography>
            </Grid>

            <br />
            <Grid style={{marginTop: 12}} container>
                <Grid item md={12} xs={12} sm={12}>
                    <TextField
                        id={generateId('text', 8)}
                        label='Content'
                        style={{
                            color: 'black',
                        }}
                        variant='outlined'
                        value={text}
                        multiline={true}
                        fullWidth
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            setText(e.target.value);
                        }}
                    />
                </Grid>
            </Grid>
            <br />
            <DialogActions>
                <Button
                    onClick={() => {
                        addingNewTextInput();
                    }}>
                    Save changes
                </Button>
                <Button onClick={() => {}}>Dismiss</Button>
            </DialogActions>
        </Grid>
    );
};
